import { render, staticRenderFns } from "./chooseGoods.vue?vue&type=template&id=32f8bda1&scoped=true"
import script from "./chooseGoods.vue?vue&type=script&lang=js"
export * from "./chooseGoods.vue?vue&type=script&lang=js"
import style0 from "./chooseGoods.vue?vue&type=style&index=0&id=32f8bda1&prod&scoped=true&lang=css"
import style1 from "./chooseGoods.vue?vue&type=style&index=1&id=32f8bda1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f8bda1",
  null
  
)

export default component.exports